import dayjs from "dayjs";

const formatDate = () => dayjs().format("YYYY-MM-DD");
const formatTime = () => dayjs().format("HH:mm:ss");

export function reducer(state, action) {
  const { type, payload} = action;
  switch (type) {
    case "SET_TITLE":
      return { ...state, title: payload };

    case "SET_CONTENT":
      return { ...state, content: payload };

    case "SET_TIMER":
      return { ...state, timer: payload };

    case "SET_PIN":
      return { ...state, pin: payload }

    case "SET_TAGS":
      return {
        ...state,
        tags: state.tags.concat(payload),
      };

    case "ADD_TAGS":
      return {
        ...state,
        tags: state.tags.concat(payload)
      };

    case "REMOVE_TAGS":
      return {
        ...state,
        tags: state.tags.filter((_, index) => index !== payload)
      };

    case "SET_DATE":
      return { ...state, date: payload };

    case "SET_DATE_TIME":
      return { ...state, time: payload };

    case "EDIT_NOTE":
      return { ...payload };

    case "CLEAR_NOTE":
      return {
        title: "",
        content: "",
        timer: "5",
        pin: false,
        tags: [],
        date: formatDate(),
        time: formatTime()
      };

    default:
      return state;
  }
}
